import { StyleSheet } from "aphrodite/no-important";
import { width } from "../style/base-theme";

export const styles = StyleSheet.create({
  container: {
    height: "100%",
    backgroundImage: "linear-gradient(-180deg, #00CAFF 0%, #0096D8 97%)"
  },
  homeViewLogo: {
    height: 13
  },
  infoCareLogo: {
    height: 20
  },
  innerContainer: {
    minWidth: 320,
    maxWidth: width.inner,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  dateTime: {
    color: "white",
    textAlign: "center",
    flex: 1
  },
  date: {
    fontWeight: 700,
    fontSize: 24,
    marginBottom: 5
  },
  infoCareImage: {
    height: 80,
    width: 80,
    borderRadius: 1000,
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)"
  },
  time: {
    fontSize: 16,
    color: "rgba(255,255,255,0.9)",
    fontWeight: 300,
    marginBottom: 0
  },
  content: {
    flex: 3,
    minHeight: 250
  },
  devices: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    alignItems: "center",
    flexDirection: "column"
  },
  device: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    marginBottom: 30,
    ":last-child": {
      marginBottom: 0
    }
  },
  link: {
    textDecoration: "none",
    display: "block"
  },
  discWrapper: {
    marginBottom: 10
  },
  title: {
    color: "#fff",
    fontSize: 18,
    fontWeight: 600,
    display: "block",
    marginBottom: 3
  },
  description: {
    color: "rgba(255,255,255,0.9)",
    fontSize: 14,
    display: "block"
  },
  signOut: {
    //display: 'block',
    background: "rgba(255,255,255,0.25)",
    borderRadius: 500,
    fontWeight: 600,
    color: "#fff",
    padding: 13,
    fontSize: 18,
    border: 0,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 260,
    cursor: "pointer",
    textDecoration: "none",
    margin: "0 auto 100px auto",
    ":hover": {
      background: "rgba(255,255,255,0.35)"
    }
  }
});
